import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import SerieService from "./serieService"
import FormList from 'base/FormList'
import { InputSwitch } from 'primereact/inputswitch'

export default function SerieList() {

    const [service] = useState(() => new SerieService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_serie',
        dsName: 'descricao_serie',
        mainField: { name: 'descricao_serie', label: 'Sigla' },
        advFields: [
            { name: 'codigo_serie', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_serie', label: 'Descrição', type: 'string', inputMode: 'text' },
            { name: 'ativa_serie', label: 'Ativa', type: 'boolean', component: 'TriStateCheckbox', value: null },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_serie" sortable header="Código"></Column>
            <Column field="sigla_serie" sortable header="Sigla"></Column>
            <Column field="descricao_serie" sortable header="Descrição"></Column>
            <Column field="prox_num_serie" sortable header="Próximo número de nota fiscal"></Column>
            <Column field="ativa_serie" sortable header="Ativa" body={e => <InputSwitch checked={e.ativa_serie === 1}></InputSwitch>}></Column>
        </FormList >
    )
}
